import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5cd23ab4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popUp" }
const _hoisted_2 = {
  class: "wrapper",
  ref: "modal"
}
const _hoisted_3 = { class: "wrapper-title" }
const _hoisted_4 = { class: "wrapper-subtitle" }
const _hoisted_5 = { class: "wrapper-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_drive_input = _resolveComponent("drive-input")!
  const _component_app_loader = _resolveComponent("app-loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$localize('app.rename.case.popup.title')) + " \"" + _toDisplayString(_ctx.iCase.title) + "\"", 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h4", null, _toDisplayString(_ctx.$localize('app.rename.case.popup.subtitle')), 1)
      ]),
      _createVNode(_component_drive_input, {
        modelValue: _ctx.caseTitle,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.caseTitle) = $event)),
        title: _ctx.$localize('app.rename.case.popup.input.title'),
        bold: "",
        onOnEnter: _ctx.renameCase,
        "disabled-enter": "",
        enterkeyhint: "done",
        error: _ctx.error
      }, null, 8, ["modelValue", "title", "onOnEnter", "error"]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", {
          class: "btn btn-cancel",
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["stop"]))
        }, _toDisplayString(_ctx.$localize('app.rename.folder.popup.cancel.button')), 1),
        _createElementVNode("a", {
          onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.renameCase && _ctx.renameCase(...args)), ["stop"])),
          class: _normalizeClass([{'disabled': _ctx.disabled}, "btn btn-create"])
        }, _toDisplayString(_ctx.$localize('app.rename.folder.popup.rename.button')), 3)
      ])
    ], 512),
    (_ctx.isLoader)
      ? (_openBlock(), _createBlock(_component_app_loader, {
          key: 0,
          message: "Renaming case..."
        }))
      : _createCommentVNode("", true)
  ]))
}